// AUTO-GENERATED by src/utils/build-global-data.mjs — do not edit by hand.
// Run `yarn generate-global-data` to refresh. Source: Contentful global-data entries (DE + de-CH + NL).
const globalData = {
  json: {
    de: {
      metadata: { tags: [], concepts: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
        id: 'wtYOE2aGXQEDbBtU64htw',
        type: 'Entry',
        createdAt: '2021-10-15T10:07:29.993Z',
        updatedAt: '2026-06-09T06:08:35.400Z',
        environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
        publishedVersion: 121,
        revision: 48,
        contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'globalData' } },
        locale: 'de',
      },
      fields: {
        title: 'Global Data',
        mainPromoBar: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '7ITJy67eQstAPppEvNxZ1r',
            type: 'Entry',
            createdAt: '2022-02-24T09:57:36.085Z',
            updatedAt: '2026-10-07T14:42:54.074Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 459,
            revision: 130,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'promoBar' } },
            locale: 'de',
          },
          fields: {
            enabled: true,
            identifier: '30Tage_Lecker_Garantie_PromoBar_180226',
            text: '30-Tage-Lecker-Garantie',
            cta: 'Mehr erfahren',
            backgroundColor: '#1A3359',
            modalId: 'lecker-garantie',
            nt_experiences: [],
          },
        },
        promoBarSmall: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '6Mvh7xM3S5GRVCgI0udQht',
            type: 'Entry',
            createdAt: '2023-06-02T13:05:27.046Z',
            updatedAt: '2023-06-22T16:40:47.076Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 27,
            revision: 7,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'promoBarSmall' } },
            locale: 'de',
          },
          fields: {
            enabled: false,
            text: 'Dein Individueller Ernährungsplan',
            link: '/futterabo/start',
            color: 'green',
            border: true,
            icon: 'link',
            promoImageMobile: {
              metadata: { tags: [], concepts: [] },
              sys: {
                space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
                id: '6fgPoEkkXwKk61ILt8bZVN',
                type: 'Asset',
                createdAt: '2023-03-23T13:05:13.476Z',
                updatedAt: '2023-03-23T13:05:13.476Z',
                environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
                publishedVersion: 3,
                revision: 1,
                locale: 'de',
              },
              fields: {
                title: 'PD-CDP-adtile-mobile-sub-new-function',
                description: '',
                file: {
                  url: '//images.ctfassets.net/s8qothrtqrf9/6fgPoEkkXwKk61ILt8bZVN/e2f12080fd4211bf13723a24b6dcb6a9/PD-CDP-adtile-mobile-sub-new-function.jpg',
                  details: { size: 70615, image: { width: 700, height: 620 } },
                  fileName: 'PD-CDP-adtile-mobile-sub-new-function.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
            nt_experiences: [],
          },
        },
        globalDiscount: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '6WTzcv1o8vmTIReWDufRxA',
              type: 'Entry',
              createdAt: '2021-11-25T19:50:12.749Z',
              updatedAt: '2025-09-03T11:57:39.897Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 319,
              revision: 104,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'discount' } },
              locale: 'de',
            },
            fields: {
              title: 'Default Discount',
              amountInPercent: 0,
              firstSubscriptionOrderDiscount: 0,
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '4SrtcXLAZryKaGDIrGLgR1',
              type: 'Entry',
              createdAt: '2026-06-09T06:07:33.985Z',
              updatedAt: '2026-07-01T07:25:45.584Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 7,
              revision: 3,
              contentType: {
                sys: { type: 'Link', linkType: 'ContentType', id: 'dynamicBundleDiscount' },
              },
              locale: 'de',
            },
            fields: {
              title: 'Dynamic Bundle Discount - Default Dog',
              discount: 20,
              petType: 'dog',
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '3eAib4SJDVOW1YDVRu84MW',
              type: 'Entry',
              createdAt: '2026-06-09T06:07:52.508Z',
              updatedAt: '2026-06-09T06:07:52.508Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 3,
              revision: 1,
              contentType: {
                sys: { type: 'Link', linkType: 'ContentType', id: 'dynamicBundleDiscount' },
              },
              locale: 'de',
            },
            fields: {
              title: 'Dynamic Bundle Discount - Default Cat',
              discount: 30,
              petType: 'cat',
            },
          },
        ],
        bonusPointCampaign: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '7i4bvpaO0taouNSgmeMasO',
            type: 'Entry',
            createdAt: '2022-01-25T11:23:24.730Z',
            updatedAt: '2023-11-07T13:10:10.772Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 127,
            revision: 47,
            contentType: {
              sys: { type: 'Link', linkType: 'ContentType', id: 'bonusPointCampaign' },
            },
            locale: 'de',
          },
          fields: {
            title: 'Default Loyalty Campaign - V04',
            conversionRate: 1,
            extraBonusPoints: 0,
            nt_experiences: [],
          },
        },
        weeklyOffers: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '3rFKMKad7aDVkmPjcp1hdT',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:46.165Z',
              updatedAt: '2026-09-07T14:35:08.515Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 78,
              revision: 14,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'Home Page Special Offer Default_Global',
              icon: 'discount',
              color: 'red',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      { data: {}, marks: [], value: 'Abonieren und sparen', nodeType: 'text' },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/pages/unser-spar-abo',
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '7IAM801XO1cR4EVMI9CHo9',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:52.177Z',
              updatedAt: '2026-09-07T14:35:12.300Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 13,
              revision: 4,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'refer a friend',
              icon: 'link',
              color: 'yellow',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: 'Markenbotschafter*in werden und ',
                        nodeType: 'text',
                      },
                      { data: {}, marks: [{ type: 'bold' }], value: '40 € ', nodeType: 'text' },
                      { data: {}, marks: [], value: 'erhalten', nodeType: 'text' },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/pages/kooperationsprogramme',
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '6N6iKzPawx0vYFALb3D7c4',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:57.467Z',
              updatedAt: '2024-03-06T09:55:00.992Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 7,
              revision: 2,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'Order history',
              icon: 'box',
              color: 'blue',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: 'Letzte Bestellung  erneut bestellen',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/account/orders',
            },
          },
        ],
        crossSellPopUp: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '4oPNF3cHY3Mx5DTmXe7FGM',
            type: 'Entry',
            createdAt: '2023-08-15T13:59:29.204Z',
            updatedAt: '2023-08-23T11:59:49.726Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 10,
            revision: 3,
            contentType: {
              sys: { type: 'Link', linkType: 'ContentType', id: 'crossSellPopUpData' },
            },
            locale: 'de',
          },
          fields: {
            title: 'Cross Sell Pop Up Baseline',
            enabled: false,
            headline: 'Test cross sell dev',
            variantId: 44086171959562,
            handle: 'snack-soft-bites-snack-chill-fur-hunde',
            nt_experiences: [],
          },
        },
        navigation: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '1m8RegiCTydwd9xPi2PmFc',
            type: 'Entry',
            createdAt: '2025-07-24T14:57:18.178Z',
            updatedAt: '2025-12-10T16:23:38.752Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 21,
            revision: 5,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'navigation' } },
            locale: 'de',
          },
          fields: { title: 'Navigation DE', element: [] },
        },
      },
    },
    'de-CH': {
      metadata: { tags: [], concepts: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
        id: '6Xmpgdxp9s2BLHernpdhNq',
        type: 'Entry',
        createdAt: '2024-01-29T15:19:25.113Z',
        updatedAt: '2026-06-09T05:47:01.827Z',
        environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
        publishedVersion: 38,
        revision: 14,
        contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'globalData' } },
        locale: 'de',
      },
      fields: {
        title: 'Global Data - CH',
        mainPromoBar: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '7xyTYVTfbqlonv1OOOyo9R',
            type: 'Entry',
            createdAt: '2024-02-15T15:04:39.990Z',
            updatedAt: '2026-09-07T14:32:13.109Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 36,
            revision: 9,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'promoBar' } },
            locale: 'de',
          },
          fields: {
            enabled: true,
            identifier: 'CH-150BP_PromoBar_010324',
            link: '/pages/bonusprogramm-lp',
            text: 'Jetzt 150 GRATIS-Punkte sichern',
            cta: 'Mehr Infos zu unserem Bonusprogramm',
            backgroundColor: '#1A3359',
            nt_experiences: [],
          },
        },
        globalDiscount: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '43onqWIEupJlg853spglZB',
              type: 'Entry',
              createdAt: '2024-02-15T15:05:14.667Z',
              updatedAt: '2024-03-06T11:05:26.689Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 15,
              revision: 7,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'discount' } },
              locale: 'de',
            },
            fields: {
              title: 'CH - Default discount ',
              amountInPercent: 0,
              firstSubscriptionOrderDiscount: 0,
              nt_experiences: [],
            },
          },
        ],
        bonusPointCampaign: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '1khWZS9SQ3t7xJCKR7fnNj',
            type: 'Entry',
            createdAt: '2024-02-15T15:06:11.855Z',
            updatedAt: '2024-03-06T09:52:25.004Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 18,
            revision: 8,
            contentType: {
              sys: { type: 'Link', linkType: 'ContentType', id: 'bonusPointCampaign' },
            },
            locale: 'de',
          },
          fields: {
            title: 'CH - Default Loyalty Campaign - V04',
            conversionRate: 1,
            extraBonusPoints: 0,
            nt_experiences: [],
          },
        },
        weeklyOffers: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '7F7twbJym3Wrd8nefMXH2x',
              type: 'Entry',
              createdAt: '2024-02-27T16:22:21.624Z',
              updatedAt: '2026-09-07T14:35:11.436Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 8,
              revision: 3,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'CH : Home Page Special Offer Default_Global',
              icon: 'discount',
              color: 'red',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      { data: {}, marks: [], value: 'Abonieren und sparen', nodeType: 'text' },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/pages/unser-spar-abo',
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '39gQjyTF5x2mJSeHU4h7I1',
              type: 'Entry',
              createdAt: '2024-03-18T14:50:17.186Z',
              updatedAt: '2024-03-18T14:50:17.186Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 3,
              revision: 1,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'CH : refer a friend ',
              icon: 'link',
              color: 'yellow',
              offerMessage: {
                nodeType: 'document',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                      {
                        nodeType: 'text',
                        value: 'Markenbotschafter*in werden und ',
                        marks: [],
                        data: {},
                      },
                      { nodeType: 'text', value: '40 CHF ', marks: [{ type: 'bold' }], data: {} },
                      { nodeType: 'text', value: 'erhalten', marks: [], data: {} },
                    ],
                  },
                ],
              },
              link: '/account/refer-friend',
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '6N6iKzPawx0vYFALb3D7c4',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:57.467Z',
              updatedAt: '2024-03-06T09:55:00.992Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 7,
              revision: 2,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'Order history',
              icon: 'box',
              color: 'blue',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: 'Letzte Bestellung  erneut bestellen',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/account/orders',
            },
          },
        ],
        navigation: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '1xaG6A04coZoFWqnHIGG2d',
            type: 'Entry',
            createdAt: '2025-07-24T15:04:19.330Z',
            updatedAt: '2025-12-10T15:42:03.727Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 22,
            revision: 6,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'navigation' } },
            locale: 'de',
          },
          fields: { title: 'Navigation CH', element: [] },
        },
      },
    },
    nl: {
      metadata: { tags: [], concepts: [] },
      sys: {
        space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
        id: '7JYbgi6RCinN38rH4dg5qQ',
        type: 'Entry',
        createdAt: '2026-08-20T09:48:45.334Z',
        updatedAt: '2026-08-20T09:48:45.334Z',
        environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
        publishedVersion: 1,
        revision: 1,
        contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'globalData' } },
        locale: 'de',
      },
      fields: {
        title: 'Global Data NL',
        mainPromoBar: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '7ITJy67eQstAPppEvNxZ1r',
            type: 'Entry',
            createdAt: '2022-02-24T09:57:36.085Z',
            updatedAt: '2026-10-07T14:42:54.074Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 459,
            revision: 130,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'promoBar' } },
            locale: 'de',
          },
          fields: {
            enabled: true,
            identifier: '30Tage_Lecker_Garantie_PromoBar_180226',
            text: '30-Tage-Lecker-Garantie',
            cta: 'Mehr erfahren',
            backgroundColor: '#1A3359',
            modalId: 'lecker-garantie',
            nt_experiences: [],
          },
        },
        promoBarSmall: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '6Mvh7xM3S5GRVCgI0udQht',
            type: 'Entry',
            createdAt: '2023-06-02T13:05:27.046Z',
            updatedAt: '2023-06-22T16:40:47.076Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 27,
            revision: 7,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'promoBarSmall' } },
            locale: 'de',
          },
          fields: {
            enabled: false,
            text: 'Dein Individueller Ernährungsplan',
            link: '/futterabo/start',
            color: 'green',
            border: true,
            icon: 'link',
            promoImageMobile: {
              metadata: { tags: [], concepts: [] },
              sys: {
                space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
                id: '6fgPoEkkXwKk61ILt8bZVN',
                type: 'Asset',
                createdAt: '2023-03-23T13:05:13.476Z',
                updatedAt: '2023-03-23T13:05:13.476Z',
                environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
                publishedVersion: 3,
                revision: 1,
                locale: 'de',
              },
              fields: {
                title: 'PD-CDP-adtile-mobile-sub-new-function',
                description: '',
                file: {
                  url: '//images.ctfassets.net/s8qothrtqrf9/6fgPoEkkXwKk61ILt8bZVN/e2f12080fd4211bf13723a24b6dcb6a9/PD-CDP-adtile-mobile-sub-new-function.jpg',
                  details: { size: 70615, image: { width: 700, height: 620 } },
                  fileName: 'PD-CDP-adtile-mobile-sub-new-function.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
            nt_experiences: [],
          },
        },
        globalDiscount: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '6WTzcv1o8vmTIReWDufRxA',
              type: 'Entry',
              createdAt: '2021-11-25T19:50:12.749Z',
              updatedAt: '2025-09-03T11:57:39.897Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 319,
              revision: 104,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'discount' } },
              locale: 'de',
            },
            fields: {
              title: 'Default Discount',
              amountInPercent: 0,
              firstSubscriptionOrderDiscount: 0,
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '4SrtcXLAZryKaGDIrGLgR1',
              type: 'Entry',
              createdAt: '2026-06-09T06:07:33.985Z',
              updatedAt: '2026-07-01T07:25:45.584Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 7,
              revision: 3,
              contentType: {
                sys: { type: 'Link', linkType: 'ContentType', id: 'dynamicBundleDiscount' },
              },
              locale: 'de',
            },
            fields: {
              title: 'Dynamic Bundle Discount - Default Dog',
              discount: 20,
              petType: 'dog',
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '3eAib4SJDVOW1YDVRu84MW',
              type: 'Entry',
              createdAt: '2026-06-09T06:07:52.508Z',
              updatedAt: '2026-06-09T06:07:52.508Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 3,
              revision: 1,
              contentType: {
                sys: { type: 'Link', linkType: 'ContentType', id: 'dynamicBundleDiscount' },
              },
              locale: 'de',
            },
            fields: {
              title: 'Dynamic Bundle Discount - Default Cat',
              discount: 30,
              petType: 'cat',
            },
          },
        ],
        bonusPointCampaign: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '7i4bvpaO0taouNSgmeMasO',
            type: 'Entry',
            createdAt: '2022-01-25T11:23:24.730Z',
            updatedAt: '2023-11-07T13:10:10.772Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 127,
            revision: 47,
            contentType: {
              sys: { type: 'Link', linkType: 'ContentType', id: 'bonusPointCampaign' },
            },
            locale: 'de',
          },
          fields: {
            title: 'Default Loyalty Campaign - V04',
            conversionRate: 1,
            extraBonusPoints: 0,
            nt_experiences: [],
          },
        },
        weeklyOffers: [
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '3rFKMKad7aDVkmPjcp1hdT',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:46.165Z',
              updatedAt: '2026-09-07T14:35:08.515Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 78,
              revision: 14,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'Home Page Special Offer Default_Global',
              icon: 'discount',
              color: 'red',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      { data: {}, marks: [], value: 'Abonieren und sparen', nodeType: 'text' },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/pages/unser-spar-abo',
              nt_experiences: [],
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '7IAM801XO1cR4EVMI9CHo9',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:52.177Z',
              updatedAt: '2026-09-07T14:35:12.300Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 13,
              revision: 4,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'refer a friend',
              icon: 'link',
              color: 'yellow',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: 'Markenbotschafter*in werden und ',
                        nodeType: 'text',
                      },
                      { data: {}, marks: [{ type: 'bold' }], value: '40 € ', nodeType: 'text' },
                      { data: {}, marks: [], value: 'erhalten', nodeType: 'text' },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/pages/kooperationsprogramme',
            },
          },
          {
            metadata: { tags: [], concepts: [] },
            sys: {
              space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
              id: '6N6iKzPawx0vYFALb3D7c4',
              type: 'Entry',
              createdAt: '2023-06-09T11:35:57.467Z',
              updatedAt: '2024-03-06T09:55:00.992Z',
              environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
              publishedVersion: 7,
              revision: 2,
              contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'adTileSlider' } },
              locale: 'de',
            },
            fields: {
              title: 'Order history',
              icon: 'box',
              color: 'blue',
              offerMessage: {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: 'Letzte Bestellung  erneut bestellen',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'document',
              },
              link: '/account/orders',
            },
          },
        ],
        crossSellPopUp: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: '4oPNF3cHY3Mx5DTmXe7FGM',
            type: 'Entry',
            createdAt: '2023-08-15T13:59:29.204Z',
            updatedAt: '2023-08-23T11:59:49.726Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 10,
            revision: 3,
            contentType: {
              sys: { type: 'Link', linkType: 'ContentType', id: 'crossSellPopUpData' },
            },
            locale: 'de',
          },
          fields: {
            title: 'Cross Sell Pop Up Baseline',
            enabled: false,
            headline: 'Test cross sell dev',
            variantId: 44086171959562,
            handle: 'snack-soft-bites-snack-chill-fur-hunde',
            nt_experiences: [],
          },
        },
        navigation: {
          metadata: { tags: [], concepts: [] },
          sys: {
            space: { sys: { type: 'Link', linkType: 'Space', id: 's8qothrtqrf9' } },
            id: 'K1rSY5tP0obRlNaehlJl3',
            type: 'Entry',
            createdAt: '2026-08-20T09:48:44.560Z',
            updatedAt: '2026-08-20T09:48:44.560Z',
            environment: { sys: { id: 'master', type: 'Link', linkType: 'Environment' } },
            publishedVersion: 1,
            revision: 1,
            contentType: { sys: { type: 'Link', linkType: 'ContentType', id: 'navigation' } },
            locale: 'de',
          },
          fields: { title: 'Navigation NL', element: [] },
        },
      },
    },
  },
};

export default globalData;
